
import React, { useEffect, useState } from 'react';
import { seoSettingsCrumb } from 'utils/breadcrumbInfo';
import CardSimple from 'screens/components/basic/CardSimple';
import Grid from 'screens/components/basic/Grid';
import { connect } from 'react-redux';
import { getSEOSettingsAction, updateSEOSettingsAction } from 'actions/EntityActions';
import { Col, Row } from 'react-bootstrap';
import { TextField } from '@mui/material';
import UploadIcon from './components/uploadIcon';
import './style.scss'
import CustomValuesHook from './components/customValuesHook';
import Button from "screens/components/basic/Button";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CodeEditor from './components/CodeEditor';
import LOOKUP from 'constants/lookup';
import { showError, showSnackbar } from 'actions/CommonActions';
import UploadLogo from './components/LogoUpload';



const SEOSettings = (props) => {
  const [state, setState] = CustomValuesHook({ customScript: "", defaultDescription: "", webSiteUrl: "", footerHtml: "", headerHtml: "", favicon: "", style: "", title: "" });
  const [favIcon, setFavIcon] = useState()
  const [logo, setLogo] = useState()



  useEffect(() => { props.getSettings(); }, [])
  useEffect(() => {
    if (props.seoSettings && props.seoSettings) {

      setState({ ...props.seoSettings })
      if (props.seoSettings.favicon) {
        setFavIcon(props.seoSettings.favicon)
      }
      if (props.seoSettings.logo) {
        setLogo(props.seoSettings.logo)
      }

    }
  }, [props.seoSettings])

  useEffect(() => {
    if (props.saveSuccess) {
      props.getSettings();
      props.showSnackbar(LOOKUP.menu.admin.SEOSetting.updateSuccessMessage)
    }
    if (props.saveError) {
      props.showError(LOOKUP.menu.admin.SEOSetting.updateErrorMessage)

    }
  }, [props.saveSuccess, props.saveError])


  const handleSubmitInfo = () => {
    props.saveSettings({
      customScript: state.customScript,
      defaultDescription: state.defaultDescription,
      webSiteUrl: state.webSiteUrl,
      footerHtml: state.footerHtml,
      headerHtml: state.headerHtml,
      favicon: props.imagePreview ? props.imagePreview : favIcon,
      title: state.title,
      style: state.style,
      logo: props.logoPreview ? props.logoPreview : logo
    })
  }

  return (
    <Grid headerContent={seoSettingsCrumb} className="seo-settings-container">
      <CardSimple title="SEO Settings" className="mt-2">
        <Row>
          <Col lg={5} sm={12} xs={12} >
            <Row>
              <Col lg={12} sm={12} xs={12} className='mb-3 mt-2'>
                <TextField
                  id="filled-textarea"
                  label="Web Site Url"
                  placeholder="Web Site Url"
                  fullWidth
                  variant="standard"
                  value={state.webSiteUrl}
                  onChange={(e) => setState({ webSiteUrl: e.target.value })}
                />
              </Col>
              <Col lg={12} sm={12} xs={12} className='mb-3 mt-2'>
                <TextField
                  id="filled-textarea"
                  label="Page Title"
                  placeholder="Web Site Url"
                  fullWidth
                  variant="standard"
                  value={state.title}
                  onChange={(e) => setState({ title: e.target.value })}
                />
              </Col>
              <Col lg={12} sm={12} xs={12} className='mb-3'>
                <TextField
                  id="filled-textarea"
                  label="Default Description"
                  placeholder="Default Description"
                  multiline
                  fullWidth
                  rows={5}
                  variant="standard"
                  value={state.defaultDescription}
                  onChange={(e) => setState({ defaultDescription: e.target.value })}
                />
              </Col>
            </Row>
          </Col>
          <Col lg={7} sm={12} xs={12} >
            <Row>

              <Col lg={6} >
                <UploadIcon favIcon={favIcon} setIcon={setFavIcon} />
              </Col>
              <Col lg={6} >
                <UploadLogo logo={logo} setLogo={setLogo} />
              </Col>

            </Row>
            <div className='mt-3 p-3'>
              <label>Uploaded Logo </label>
        
                <TextField
                id="filled-textarea"
                fullWidth
                variant="standard"
                InputProps={{
                  readOnly: true,
                }}
                value={logo?logo:"Logo not uploaded"}
                onChange={(e) => setState({ webSiteUrl: e.target.value })}
              />
              

            </div>
          </Col>
        </Row>
        <Row className='mt-5'>

          <Col lg={6} sm={12} xs={12} className='mb-2'>
            <CodeEditor
              label={"Header Html"}
              value={state.footerHtml || ""}
              language={'html'}
              onChange={(value) => setState({ footerHtml: value })}
            />
          </Col>
          <Col lg={6} sm={12} xs={12} className='mb-2'>
            <CodeEditor
              label={"Footer Html"}
              value={state.headerHtml || ""}
              language={'html'}
              onChange={(value) => setState({ headerHtml: value })}
            />
          </Col>

          <Col lg={6} sm={12} xs={12} className='mb-2'>
            <CodeEditor
              label={"Custom Script"}
              value={state.customScript || ""}
              language={'javascript'}
              onChange={(value) => setState({ customScript: value })}
            />

          </Col>
          <Col lg={6} sm={12} xs={12} className='mb-2'>
            <CodeEditor
              label={"Page Style"}
              value={state.style || ""}
              language={'css'}
              onChange={(value) => setState({ style: value })}
            />
          </Col>
        </Row>


        <div>
          <Button
            type="IconInButton"
            className="bg-light-green"
            label={"Save Settings"}
            icon={<SaveAltIcon />}
            dispatch={props.savePending}
            onTouchTap={handleSubmitInfo} />
        </div>

      </CardSimple>
    </Grid>
  )
}
const mapStateToProps = (state) => ({
  getPending: state.entity.getSEOSettingsPending,
  savePending: state.entity.updateSEOSettingsPending,
  seoSettings: state.entity.seoSettings,
  saveSuccess: state.entity.updateSEOSettingsSuccess,
  saveError: state.entity.updateSEOSettingsError,

  imagePreview: state.form.SEOSettingsIconImageURL,
  logoPreview: state.form.SEOSettingsLogoImageURL
})

const mapDispatchToProps = (dispatch) => ({
  getSettings: () => dispatch(getSEOSettingsAction()),
  saveSettings: (params) => dispatch(updateSEOSettingsAction(params)),
  showSnackbar: (message) => dispatch(showSnackbar(message)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SEOSettings)


